import { useState, useEffect, useCallback } from 'react';
import { PUZZLE_CONFIG } from '../config/puzzleConfig';
import { initializePuzzle, checkComplete, canMovePiece, movePiece } from '../utils/puzzleUtils';

export const usePuzzle = () => {
  const [puzzleSize, setPuzzleSize] = useState(PUZZLE_CONFIG.defaultSize);
  const [puzzle, setPuzzle] = useState([]);
  const [moves, setMoves] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [movingPiece, setMovingPiece] = useState(null);

  // 퍼즐 초기화
  const initializeGame = useCallback(() => {
    const newPuzzle = initializePuzzle(puzzleSize);
    setPuzzle(newPuzzle);
    setMoves(0);
    setIsComplete(false);
    setMovingPiece(null);
  }, [puzzleSize]);

  // 조각 클릭 처리
  const handlePieceClick = useCallback((pieceIndex) => {
    if (!canMovePiece(pieceIndex, puzzle, puzzleSize)) return;

    setMovingPiece(pieceIndex);
    
    setTimeout(() => {
      const newPuzzle = movePiece(pieceIndex, puzzle, puzzleSize);
      setPuzzle(newPuzzle);
      setMoves(prev => prev + 1);
      setMovingPiece(null);

      // 완성 확인
      if (checkComplete(newPuzzle)) {
        setTimeout(() => {
          setIsComplete(true);
        }, PUZZLE_CONFIG.completionDelay);
      }
    }, PUZZLE_CONFIG.animationDuration);
  }, [puzzle, puzzleSize]);

  // 퍼즐 크기 변경
  const changePuzzleSize = useCallback((newSize) => {
    setPuzzleSize(newSize);
    // 크기 변경 시 완성 상태 리셋
    setIsComplete(false);
  }, []);

  // 셔플
  const shufflePuzzle = useCallback(() => {
    initializeGame();
  }, [initializeGame]);

  // 리셋
  const resetGame = useCallback(() => {
    initializeGame();
  }, [initializeGame]);

  // 퍼즐 크기 변경 시 자동 초기화
  useEffect(() => {
    initializeGame();
  }, [initializeGame]);

  return {
    puzzleSize,
    puzzle,
    moves,
    isComplete,
    movingPiece,
    handlePieceClick,
    changePuzzleSize,
    shufflePuzzle,
    resetGame
  };
}; 